import type { NavItem } from './types';

interface NavLink {
  label: string;
  children?: { label: string }[];
}

export function buildNavLinks(items: NavItem[]): {
  links: NavLink[];
  loginLink: { label: string };
  cta: { label: string };
} {
  const dropdownParents = items
    .filter((i) => i.type === 'dropdown_parent')
    .sort((a, b) => a.order - b.order);

  const topLinks = items
    .filter((i) => i.type === 'link')
    .sort((a, b) => a.order - b.order);

  const children = items
    .filter((i) => i.type === 'dropdown_child')
    .sort((a, b) => a.order - b.order);

  // Merge parents and top-level links, then sort by order so the CMS
  // order value controls the final sequence regardless of type.
  const allTop = [
    ...dropdownParents.map((p) => ({
      label: p.label,
      order: p.order,
      children: children
        .filter((c) => c.parent === p.label)
        .map((c) => ({ label: c.label })),
    })),
    ...topLinks.map((l) => ({ label: l.label, order: l.order })),
  ].sort((a, b) => a.order - b.order);

  const links: NavLink[] = allTop.map(({ label, children: ch }) => {
    const link: NavLink = { label };
    if (ch?.length) link.children = ch;
    return link;
  });

  const login = items.find((i) => i.type === 'login');
  const cta = items.find((i) => i.type === 'cta');

  return {
    links,
    loginLink: { label: login?.label ?? 'Log in' },
    cta: { label: cta?.label ?? 'Sign Up' },
  };
}
